module.exports = __webpack_public_path__ + "img/20210910101924269k4e.ad62f3c2.png";